import { useEffect } from 'react';
import { useAdminCustomization } from '@/hooks/useAdminCustomization';

const FONT_OPTIONS = [
  { value: 'inter', label: 'Inter', family: 'Inter, sans-serif', url: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap' },
  { value: 'roboto', label: 'Roboto', family: 'Roboto, sans-serif', url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap' },
  { value: 'poppins', label: 'Poppins', family: 'Poppins, sans-serif', url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap' },
  { value: 'montserrat', label: 'Montserrat', family: 'Montserrat, sans-serif', url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap' },
  { value: 'lato', label: 'Lato', family: 'Lato, sans-serif', url: 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap' },
  { value: 'opensans', label: 'Open Sans', family: '"Open Sans", sans-serif', url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap' },
  { value: 'playfair', label: 'Playfair Display', family: '"Playfair Display", serif', url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap' },
  { value: 'merriweather', label: 'Merriweather', family: 'Merriweather, serif', url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap' },
];

export const BrandingProvider = ({ children }: { children: React.ReactNode }) => {
  const { customization, loading } = useAdminCustomization();

  useEffect(() => {
    if (!customization) return;

    console.log('🎨 Applying branding customization:', customization);

    // Apply font
    const fontFamily = customization.font_family || 'inter';
    const selectedFont = FONT_OPTIONS.find(f => f.value === fontFamily);
    
    if (selectedFont) {
      // Load font if not already loaded
      const existingLink = document.querySelector(`link[data-font="${fontFamily}"]`);
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = selectedFont.url;
        link.setAttribute('data-font', fontFamily);
        document.head.appendChild(link);
        console.log('✅ Font loaded:', selectedFont.label);
      }
      
      // Apply font to body and root
      document.body.style.fontFamily = selectedFont.family;
      document.documentElement.style.setProperty('--font-family', selectedFont.family);
      console.log('✅ Font applied:', selectedFont.family);
    }

    // Apply primary color
    const primaryColor = customization.primary_color || '221 83% 53%';
    document.documentElement.style.setProperty('--primary', primaryColor);
    console.log('✅ Primary color applied:', primaryColor);
    
  }, [customization]);

  return <>{children}</>;
};
